import styled from 'styled-components'

const ProgressBar = ({ pct }: { pct: number }) => {
  return (
    <Container>
      <Bar style={{ width: `${pct}%` }}></Bar>
    </Container>
  )
}

const Container = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  height: 1rem;
  background-color: ${({ theme }) => theme.backgroundColor};
`

const Bar = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.invertedBackgroundColor};
`

export default ProgressBar
